import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {  Router} from 'react-router-dom';
import createHistory from "history/createBrowserHistory";

const history = createHistory()
  

ReactDOM.render( 
    <Router history={history}>
         <App />  
    </Router>      
    // <App/>   
    , document.getElementById('root'));

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js